import React, { useState } from "react";
import { useDoctorContext } from "../../contexts";
import { Doctor } from "../../models";
import { TablePagination } from "../Common";
import { DOCTOR_TABLE_PAGE_SIZE } from "../../constants";
import CircularProgress from "@mui/material/CircularProgress";
import { ConfirmLogoutModal } from "./ConfirmLogoutModal";

export const DoctorsTable = React.memo(() => {
	const { telehealthDoctors, setRefreshTelehealthDoctors } = useDoctorContext();
	const [pagedDoctors, setPagedDoctors] = useState<Doctor[]>([]);
	const [openConfirmLogoutModal, setOpenConfirmLogoutModal] = useState(false);
	const [selectedDoctor, setSelectedDoctor] = useState<Doctor | undefined>(
		undefined
	);

	const logoutDoctor = async (doctor: Doctor) => {
		setSelectedDoctor(doctor);
		setOpenConfirmLogoutModal(true);
	};
	const closeConfirmLogoutModal = (updated: boolean) => {
		setSelectedDoctor(undefined);
		setOpenConfirmLogoutModal(false);
		if (updated) {
			setRefreshTelehealthDoctors(true);
		}
	};
	const handlePageChange = (doctors: Doctor[]) => {
		setPagedDoctors(doctors);
	};

	return (
		<>
			{telehealthDoctors != null ? (
				<>
					<table className="ch-table w-full">
						<thead>
							<tr>
								<th scope="col">Doctor</th>
								<th scope="col">Active</th>
								<th scope="col">Stop Taking Patients</th>
								<th scope="col"></th>
							</tr>
						</thead>
						<tbody>
							{pagedDoctors?.map((doctor) => (
								<tr key={doctor.id}>
									<td>{doctor.displayName}</td>
									<td>
										<div
											className={`ch-chip ${doctor.availableTelehealth ? "ch-chip-active" : "ch-chip-inactive"}`}
										>
											{doctor.availableTelehealth ? "Active" : "Inactive"}
										</div>
									</td>
									<td>
										{doctor.availableTelehealth && (
											<div
												className={`ch-chip ${doctor.takingPatientsTelehealth ? "ch-chip-active" : "ch-chip-inactive"}`}
											>
												{doctor.takingPatientsTelehealth
													? "Active"
													: "Inactive"}
											</div>
										)}
									</td>
									<td>
										<button
											className="ch-button ch-button-primary"
											onClick={() => logoutDoctor(doctor)}
										>
											Logout
										</button>
									</td>
								</tr>
							))}
						</tbody>
					</table>
					<TablePagination
						items={telehealthDoctors || []}
						pageSize={DOCTOR_TABLE_PAGE_SIZE}
						pageChange={handlePageChange}
					/>
					{selectedDoctor && (
						<ConfirmLogoutModal
							open={openConfirmLogoutModal}
							doctor={selectedDoctor}
							close={closeConfirmLogoutModal}
						/>
					)}
				</>
			) : (
				<div className="flex flex-col justify-center items-center">
					<CircularProgress size={60} />
				</div>
			)}
			{telehealthDoctors == null ||
				(telehealthDoctors.length === 0 && (
					<div className="flex justify-center ch-xl-text ch-em-text-navy mt-5">
						There are no telehealth doctors
					</div>
				))}
		</>
	);
});
